function dedup(rows) {

  const unique = [];
  const seen = {};

  for (let row of rows) {

    if (seen[row.data._id] === true) {
      continue;
    }

    seen[row.data._id] = true;

    unique.push(row);

  }

  return unique;

}

function groupRecentSearchesByTime(responseData) {

  const groups = {
    today: dedup(responseData.today),
    pastWeek: dedup(responseData.lastSevenDays),
    pastMonth: dedup(responseData.last30Days)
  };

  return groups;

}

export {
  groupRecentSearchesByTime
};